module.exports = __webpack_public_path__ + "static/media/catgun.49227036.png";